"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialogAnchorGlue = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Logger_1 = require("../utilities/Logger");
function useDialogAnchorGlue() {
    const [showingDialog, setShowingDialog] = react_1.default.useState(false);
    const anchorRef = react_1.default.useRef(null);
    const getAnchorClientRect = react_1.default.useCallback(() => { var _a, _b, _c; return (_c = (_b = (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()) !== null && _c !== void 0 ? _c : undefined; }, [anchorRef]);
    const showDialog = react_1.default.useCallback(() => {
        setShowingDialog(true);
        Logger_1.Logger.info('show');
    }, [setShowingDialog]);
    const hideDialog = react_1.default.useCallback(() => {
        setShowingDialog(false);
        Logger_1.Logger.info('hide');
    }, [setShowingDialog]);
    return { anchorRef, getAnchorClientRect, showingDialog, showDialog, hideDialog };
}
exports.useDialogAnchorGlue = useDialogAnchorGlue;
//# sourceMappingURL=useDialogAnchorGlue.js.map